<template>
    <div>
        Loaded
        <v-text-field
            label="Fichier"
            v-model="fileName"
            @click="$refs.inputUpload.click()"
            prepend-icon="mdi-attach-file"
            style="width: 100%; margin-right: auto; margin-left: auto"
            density="compact"
        />
        <input v-show="false" ref="inputUpload" type="file" accept=".pdf" @change="onFileChanged" />

        <v-row v-if="document" no-gutters>
            <v-col cols="12"> Date: {{ document.date }} </v-col>
            <v-col cols="12">
                TTC: {{ document.netAmount }} | HT: {{ document.grossAmount }} | TVA:
                {{ document.vatAmount }}
            </v-col>
            <v-col cols="12"> Name: {{ document.name }} </v-col>
            <v-col cols="12"> Type: {{ document.type }} </v-col>
            <v-col cols="12"> Company: {{ document.seller ? document.seller.name : null }} </v-col>
            <v-col cols="12" v-if="document && document.multiVats">
                <v-row v-for="(line, index) in document.multiVats" :key="index" no-gutters>
                    <v-col cols="3"> {{ line.vatAmount }} </v-col>
                    <v-col cols="3"> {{ line.vatRate }} </v-col>
                    <v-col cols="3"> {{ line.grossAmount }} </v-col>
                    <v-col cols="3">
                        {{ line.category || (line.vatRate === 0 ? "Pas défini" : null) }}
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import { getDocument } from "../services/facturX";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class FacturX extends Vue {
    fileName = "";

    document = {};

    get company() {
        return this.$store.state.selected_company;
    }

    async onFileChanged(e) {
        if (e && e.target && e.target.files) {
            const file = e.target.files[0];
            this.fileName = file.name;
            const self = this;
            const reader = new FileReader();
            reader.onload = async () => {
                if (reader.result) {
                    let content = reader.result.toString();
                    let xml = content.substring(
                        content.indexOf("<?xml version='1.0' encoding='UTF-8'?>"),
                    );
                    xml = xml.split("endstream")[0];
                    self.document = getDocument(xml, this.company);
                }
            };
            await reader.readAsText(file);
        }
    }
}

export default toNative(FacturX);
</script>
